export default "__VITE_PUBLIC_ASSET__18b45d08__"